module.exports = __webpack_public_path__ + "img/about-contact.2fc16f57.png";